export default __webpack_public_path__ + "static/media/erik-odiin-jbQvJx2EWnU-unsplash.4adffd36.jpg";